import * as Sentry from '@sentry/react'

export const addUserToSentry = store => next => (action: any) => {
  Sentry.configureScope(scope => {
    scope.setUser({
      id: store.getState()?.user?.id
    })
  })

  return next(action)
}
